__turbopack_context__.v({
  "backgroundImageAndGradients": "TopArtistSection-module__NeQzxG__backgroundImageAndGradients",
  "container": "TopArtistSection-module__NeQzxG__container",
  "content": "TopArtistSection-module__NeQzxG__content",
  "styledButton": "TopArtistSection-module__NeQzxG__styledButton",
  "subTitle": "TopArtistSection-module__NeQzxG__subTitle",
  "title": "TopArtistSection-module__NeQzxG__title",
});
